import api from '@/api';
export default {
	// 회의실 자원목록 가져오기
	getConferenceResource(comCode: string) {
		return api.get<calendar.ConferenceResourceItem[]>({
            url: `/IsuReserveResource/ISU_Calendar/api/conference/list?comCode=${comCode}`,
        });
	},

	// 자원예약, 일정 매핑 create
	createReserveRequestCalendarMap(data: calendar.RequestCalendarMap) {
		return api.post({
            url: `/IsuReserveResource/ISU_Calendar/api/create/map`,
            data: data
        })
	},

	// 자원예약, 일정 매핑 update
	updateReserveRequestCalendarMap(data: calendar.RequestCalendarMap) {
		return api.post({
            url: `/IsuReserveResource/ISU_Calendar/api/update/map`,
            data: data
        })
	},

    // 자원예약, 일정 매핑 update
	deleteReserveRequestCalendarMap(reserveRequestId: number) {
		return api.post({
            url: `/IsuReserveResource/ISU_Calendar/api/delete/map?reserveRequestId=${reserveRequestId}`,
        })
	},

	// 자원예약 요청 create
	createReserveRequest: (data: calendar.RequestRequestItem): Promise<number> => {
        return api.post({
            url: `/IsuReserveResource/ISU_RequestDb/api/create`,
            data: data
        })
    },

	// 자원예약 요청 update
	updateReserveRequest: (data: calendar.RequestRequestItem): Promise<boolean> => {

        return api.post({
            url: `/CommonReserveDb/requestdb/api`,
            data: data
        })

    },

    // 자원예약 삭제 delete
    cancelReserveRequest: (data: calendar.RequestCancelParam): Promise<boolean> => {

        return api.post({
            url: `/CommonReserveDb/requestdb/api/cancel`,
            data: data
        })

    },

	// 자원예약 요청 유효성 확인
	validationReserveRequest: (data: calendar.RequestValdationRequest): Promise<boolean> => {
        return api.post({
            url: `/CommonReserveDb/requestdb/validation/api`,
            data: data
        })
    },

	// 자원예약 요청 유효성 확인
	validationReserveRequestIncludeWait: (data: calendar.RequestValdationRequest): Promise<boolean> => {

        return api.post({
            url: `/IsuReserveResource/ISU_RequestDb/validation/api/include/wait`,
            data: data
        })
    },

	// 자원예약, 일정 매핑 값 가져오기
	getMapByCalendarItemId(id: string) {
		return api.get({
            url: `/IsuReserveResource/ISU_Calendar/api/map?calendarItemId=${id}`,
        });
	}
}
